import { lazy, LazyExoticComponent, ComponentType } from 'react';

/**
 * Maps a concept's frontmatter `demo:` key to its live demo component.
 * Lazy-loaded so demo code only ships when a concept page uses it.
 */
const demoRegistry: Record<string, LazyExoticComponent<ComponentType<any>>> = {
  useState: lazy(() => import('../reactHooks/hook_types/state')),
  useEffect: lazy(() => import('../reactHooks/hook_types/effect')),
  useContext: lazy(() => import('../reactHooks/hook_types/context')),
  useRef: lazy(() => import('../reactHooks/hook_types/ref')),
  useReducer: lazy(() => import('../reactHooks/hook_types/Reducer')),
  useMemo: lazy(() => import('../reactHooks/hook_types/memo')),
  useCallback: lazy(() => import('../reactHooks/hook_types/callback')),
  useLayoutEffect: lazy(() => import('../reactHooks/hook_types/layout_effect')),
};

export default demoRegistry;
